import { Clock } from 'lucide-react';
import { signOutWithAudit } from '../utils/signOutWithAudit';
import { useTheme } from '../context/ThemeContext';
import { colors } from '../utils/theme';
import BrandLogo from '../components/shared/BrandLogo';

const WA_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER ?? '51999999999';

export default function WaitlistPendingScreen() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const c = colors(isDark);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: c.canvas }}
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <BrandLogo size={56} className="mb-4" />
        </div>

        <div
          className="rounded-2xl p-8 shadow-2xl text-center"
          style={{ background: c.card, border: `1px solid ${c.border}` }}
        >
          <div
            className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-5"
            style={{
              background: 'var(--brand-soft)',
              border: '1px solid var(--brand-bd)',
            }}
          >
            <Clock size={26} style={{ color: 'var(--link)' }} />
          </div>

          <h2
            className="text-xl font-bold mb-3"
            style={{ color: c.textPrimary }}
          >
            Tu solicitud fue recibida
          </h2>

          <p
            className="text-sm leading-relaxed mb-6"
            style={{ color: c.textNormal }}
          >
            Estamos revisando tu registro. Te notificaremos cuando tu acceso
            esté activo.
          </p>

          <div
            className="rounded-xl p-4 mb-6 text-sm text-left"
            style={{
              background: c.cardAlt,
              border: `1px solid ${c.borderSoft}`,
            }}
          >
            <p className="font-semibold mb-1" style={{ color: c.textPrimary }}>
              ¿Tienes preguntas?
            </p>
            <a
              href={`https://wa.me/${WA_NUMBER}`}
              target="_blank"
              rel="noreferrer"
              className="hover:underline"
              style={{ color: 'var(--link)' }}
            >
              Escríbenos por WhatsApp →
            </a>
          </div>

          <button
            onClick={() => void signOutWithAudit('manual')}
            className="w-full py-2.5 rounded-xl text-sm font-medium transition-colors"
            style={{
              background: c.subtleBg,
              color: c.textNormal,
              border: `1px solid ${c.border}`,
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
